import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from "react";
import { getAllThemeNames } from "./themeUtils";
import { hasValue } from "@utils";
import { UXPContext } from "@core/context/Context";
import { Dropdown } from "@widget/popups/Dropdown";
import ProfileImage from "@widget/other/ProfileImage";
import ActionsListComponent from "@widget/list/Tables/Common/ActionListComponent";
/**
 * @export
 * A floating dropdown menu that allows users to change the active theme.
 *
 * @example
 * ```tsx
 * <ThemeChanger
 *   themeName="dark"
 *   onChangeTheme={(theme) => console.log("Theme changed:", theme)}
 *   position="bottom-left"
 * />
 * ```
 */
const ThemeChanger = (props) => {
    const context = useContext(UXPContext);
    const themes = getAllThemeNames((context === null || context === void 0 ? void 0 : context.customThemes) || {});
    useEffect(() => {
        if (hasValue(props === null || props === void 0 ? void 0 : props.themeName) && context.themeName !== (props === null || props === void 0 ? void 0 : props.themeName)) {
            context.onChangeTheme(props === null || props === void 0 ? void 0 : props.themeName, props === null || props === void 0 ? void 0 : props.rootElementId);
        }
    }, [props === null || props === void 0 ? void 0 : props.themeName]);
    if (themes.length <= 1)
        return null;
    return (_jsx(Dropdown, { trigger: _jsx(ProfileImage, { image: ['fas', 'palette'], bgColor: "transparent" }), content: _jsx(ActionsListComponent, { actions: (themes || []).map((t) => ({
                label: context.$L(t),
                value: t,
                onClick: () => {
                    var _a;
                    context.onChangeTheme(t, props.rootElementId);
                    (_a = props === null || props === void 0 ? void 0 : props.onChangeTheme) === null || _a === void 0 ? void 0 : _a.call(props, t);
                }
            })), selectedValue: context.themeName }), position: (props === null || props === void 0 ? void 0 : props.position) || 'bottom-right' }));
};
export default ThemeChanger;
